"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelFlomni = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelFlomni = function SvgChannelFlomni(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#sc_flomni__paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.633 39.9413V56.5567L68.5777 55.3542C70.7642 55.2449 72.5133 55.7915 73.9345 57.2125C75.3556 58.6336 76.0116 60.3826 76.0116 62.4595C76.0116 64.5364 75.2463 66.3947 73.9345 67.925C72.5133 69.4554 70.7642 70.3299 68.5777 70.4392L51.633 71.6416V88.6942C51.633 90.8804 50.8678 92.7388 49.4466 94.2691C48.0254 95.7995 46.167 96.674 43.9806 96.7833C41.7942 96.8926 40.045 96.346 38.5145 95.0343C37.0934 93.7226 36.3281 91.9736 36.3281 89.7873V33.4919C36.3281 31.5243 37.0934 29.7754 38.5145 28.1357C39.9357 26.496 41.7942 25.5122 43.9806 25.4029L76.0116 23.2167C78.0887 23.1074 79.8378 23.6539 81.3683 25.075C82.7894 26.496 83.5547 28.245 83.5547 30.3219C83.5547 32.5081 82.7894 34.3664 81.3683 35.8968C79.9471 37.4272 78.0887 38.3016 76.0116 38.411L51.633 39.9413Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_flomni__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#4676D9"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#1B4FB9"
  }))));
};

exports.SvgChannelFlomni = SvgChannelFlomni;